import PopConfirm from './PopConfirm';

export default PopConfirm;



// WEBPACK FOOTER //
// ./src/components/pop-confirm/index.js